var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center ma-2q",staticStyle:{"text-align":"center"}},[_c('h3',{staticClass:"text-uppercase"},[_vm._v(" "+_vm._s(this.imageName)+" ")]),_c('img',{staticStyle:{"max-width":"100%"},attrs:{"src":_vm.theImagePath}})])
}
var staticRenderFns = []

export { render, staticRenderFns }